// ServiceTechnicianPage.jsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from "../Api.js";
import { getAuthenticatedSessionToken, getUserSessionToken } from '../utils/auth';
import img1 from "../assets/serivices/pest control.png";
import img2 from "../assets/serivices/electrician.png";
import img3 from "../assets/serivices/plumber.png";
import img4 from "../assets/serivices/hair.png";
import img5 from "../assets/serivices/massage.png";
import img6 from "../assets/serivices/electrician.png";
import img7 from "../assets/serivices/plumber.png";
import img8 from "../assets/serivices/carpenter.png";
import img9 from "../assets/serivices/mechanic.png";
import img10 from "../assets/serivices/delivery.png";
import './ServiceTechnicianPage.css';

const fallbackImages = [
  img1, img2, img3, img4, img5, img6, img7, img8, img9, img10
];

const ServiceTechnicianPage = () => {
  const { serviceId } = useParams();
  const navigate = useNavigate();
  
  const [services, setServices] = useState([]);
  const [technicians, setTechnicians] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [loading, setLoading] = useState(true);
  const [techniciansLoading, setTechniciansLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchServices();
  }, []);

  useEffect(() => {
    if (serviceId && services.length > 0) {
      const service = services.find(s => s._id === serviceId);
      if (service) {
        setSelectedService(service);
        fetchTechnicians(serviceId);
      }
    }
  }, [serviceId, services]);

  const fetchServices = async () => {
    try {
      setLoading(true);
      const response = await api.get('/api/web/available-services');
      
      if (response.data.success) {
        const activeServices = response.data.data.services.filter(s => s.status === true);
        setServices(activeServices);
        setError(null);
        
        // If no serviceId in URL, select first service
        if (!serviceId && activeServices.length > 0) {
          navigate(`/services/${activeServices[0]._id}`, { replace: true });
        }
      } else {
        setError('Failed to fetch services');
      }
    } catch (err) {
      console.error('Error fetching services:', err);
      setError('Failed to load services. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const fetchTechnicians = async (serviceId) => {
    try {
      setTechniciansLoading(true);
      // Update API endpoint based on your response
      const response = await api.get(`/api/web/technicians-by-service/${serviceId}`);
      // Or if your endpoint is different:
      // const response = await api.get(`/api/web/service/${serviceId}/technicians`);
      
      console.log('Technicians response:', response.data); // For debugging
      
      // Handle the response structure from your API
      if (response.data.success) {
        // The response data is directly an array of technicians
        const techniciansData = response.data.data || [];
        setTechnicians(techniciansData);
      } else {
        setTechnicians([]);
      }
    } catch (err) {
      console.error('Error fetching technicians:', err);
      setTechnicians([]);
    } finally {
      setTechniciansLoading(false);
    }
  };

  const handleServiceClick = (service) => {
    setSelectedService(service);
    navigate(`/services/${service._id}`);
    fetchTechnicians(service._id);
  };


  

const handleProfileView = async (technicianId) => {
  try {
    const token = getUserSessionToken();

    if (!token) {
      if (getAuthenticatedSessionToken()) {
        navigate(`/tech-profile/${technicianId}`);
        return;
      }
      navigate("/login?tab=user");
      return;
    }

    const response = await api.post(
      "/api/web/technicians/view-create-log",
      {
        technicianId: technicianId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data.success) {
      navigate(`/tech-profile/${technicianId}`);
    } else {
      alert(
        "You are not authorized to view this profile. Please log in as a user."
      );
    }
  } catch (error) {
    console.error("Profile view error:", error);

    if (error.response?.status === 401) {
      navigate("/login?tab=user");
    } else {
      alert(
        error.response?.data?.message || "Something went wrong. Please try again."
      );
    }
  }
};
const handlecall = async (technician) => {
  try {
    const token = getUserSessionToken();

    if (!token) {
      navigate("/login?tab=user");
      return;
    }

    const response = await api.post(
      "/api/web/technicians/view-create-log",
      {
        technicianId: technician.technician_id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data.success) {
      window.location.href = `tel:${technician.mobile}`;
    } else {
      alert(
        "You are not authorized to view this profile. Please log in as a user."
      );
    }
  } catch (error) {
    console.error("Profile view error:", error);

    if (error.response?.status === 401) {
      navigate("/login?tab=user");
    } else {
      alert(
        error.response?.data?.message || "Something went wrong. Please try again."
      );
    }
  }
};
  const getFallbackImage = (index) => {
    return fallbackImages[index % fallbackImages.length];
  };

  const getServiceType = (title) => {
    return title.toLowerCase().replace(/\s+/g, '-');
  };

  const filteredServices = services.filter(service =>
    service.availableserviceTitle.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <div className="st-page">
        <div className="st-container">
          <div className="st-loading">
            <div className="st-loading-spinner"></div>
            <p>Loading services...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="st-page">
        <div className="st-container">
          <div className="st-error">
            <h2>Error</h2>
            <p>{error}</p>
            <button onClick={() => navigate('/')}>Go Back Home</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="st-page">
      <div className="st-container">
        <div className="st-header">
          <h1 className="st-title">Services & Technicians</h1>
          <p className="st-subtitle">Select a service to view available technicians</p>
        </div>

        <div className="st-content">
          {/* Left Side - Services List */}
          <div className="st-services-sidebar">
            <div className="st-search-box">
              <input
                type="text"
                placeholder="Search services..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="st-search-input"
              />
              <svg className="st-search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8" />
                <path d="M21 21l-4.35-4.35" />
              </svg>
            </div>

            <div className="st-services-list">
              {filteredServices.length > 0 ? (
                filteredServices.map((service, index) => (
                  <div
                    key={service._id}
                    className={`st-service-item ${selectedService?._id === service._id ? 'st-service-active' : ''}`}
                    onClick={() => handleServiceClick(service)}
                  >
                    <div className="st-service-icon">
                      <img
                        src={service.availableserviceLogo || getFallbackImage(index)}
                        alt={service.availableserviceTitle}
                        className="st-service-image"
                        onError={(e) => {
                          e.target.src = getFallbackImage(index);
                        }}
                      />
                    </div>
                    <div className="st-service-info">
                      <h3 className="st-service-name">{service.availableserviceTitle}</h3>
                      <div className="st-service-meta">
                        <span className="st-service-price">
                          From ${service.availablestartPrice}
                        </span>
                        <span className="st-service-duration">
                          {service.availableserviceDuration}
                        </span>
                      </div>
                      {selectedService?._id === service._id && (
                        <span className="st-service-selected">✓ Selected</span>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <div className="st-no-services">
                  <p>No services found matching your search</p>
                </div>
              )}
            </div>
          </div>

          {/* Right Side - Technicians */}
          <div className="st-technicians-content">
            {selectedService ? (
              <>
                <div className="st-technicians-header">
                  <h2 className="st-technicians-title">
                    {selectedService.availableserviceTitle} Technicians
                  </h2>
                  <div className="st-technicians-stats">
                    <span className="st-technicians-count">
                      {technicians.length} {technicians.length === 1 ? 'Technician' : 'Technicians'} Available
                    </span>
                  </div>
                </div>

                {techniciansLoading ? (
                  <div className="st-technicians-loading">
                    <div className="st-loading-spinner"></div>
                    <p>Loading technicians...</p>
                  </div>
                ) : (
                  <div className="st-technicians-grid">
                    {technicians.length > 0 ? (
                      technicians.map((technician, index) => (
                        <div key={technician._id || index} className="st-technician-card">
                          <div className="st-technician-avatar">
                            <img
                              src={
                                technician.profile_pic || 
                                `https://ui-avatars.com/api/?name=${technician.name}&background=007bff&color=fff&size=80`
                              }
                              alt={technician.name}
                              className="st-technician-image"
                              onError={(e) => {
                                e.target.src = `https://ui-avatars.com/api/?name=${technician.name}&background=007bff&color=fff&size=80`;
                              }}
                            />
                            {/* Optional: Add online status if available in your data */}
                            {/* {technician.isOnline && (
                              <span className="st-online-badge"></span>
                            )} */}
                          </div>
                          <div className="st-technician-details">
                            <h4 className="st-technician-name">{technician.name}</h4>
                            <p className="st-technician-expertise">
                              {technician.specialty || technician.expertise || 'Professional'}
                            </p>
                            {/* <div className="st-technician-info-row">
                              <span className="st-technician-email">
                                📧 {technician.email}
                              </span>
                              <span className="st-technician-phone">
                                📱 {technician.mobile}
                              </span>
                            </div> */}
                            {/* Optional: Add rating if available */}
                            {/* <div className="st-technician-rating">
                              <span className="st-stars">★★★★★</span>
                              <span className="st-rating">({technician.rating || 4.5})</span>
                            </div> */}
                            <div className="st-technician-actions">
                              <button className="st-book-btn" onClick={() => handlecall(technician)}>
                                Call Now
                              </button>
                              <button className="st-profile-btn" onClick={() => handleProfileView(technician.technician_id)}>
                                View Profile
                              </button>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="st-no-technicians">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <circle cx="12" cy="12" r="10" />
                          <line x1="12" y1="8" x2="12" y2="12" />
                          <line x1="12" y1="16" x2="12.01" y2="16" />
                        </svg>
                        <h3>No Technicians Available</h3>
                        <p>We couldn't find any technicians for this service at the moment.</p>
                        <p className="st-no-technicians-hint">Please try selecting another service.</p>
                      </div>
                    )}
                  </div>
                )}
              </>
            ) : (
              <div className="st-select-service-prompt">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
                <h2>Select a Service</h2>
                <p>Choose a service from the left panel to see available technicians</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceTechnicianPage;